import { signal } from '@preact/signals';
import { useRef } from 'preact/hooks';
import { AttachMenu } from '../AttachMenu';
import type { ComponentShowcase } from '../registry';

const demoOpen = signal(false);

function AttachMenuExample() {
  const fileRef = useRef<HTMLInputElement>(null);
  return (
    <div style={{ position: 'relative', minHeight: 60 }}>
      <input ref={fileRef} type="file" style={{ display: 'none' }} />
      <AttachMenu menuOpen={demoOpen} fileInputRef={fileRef} />
    </div>
  );
}

export const showcase: ComponentShowcase = {
  name: 'AttachMenu',
  category: '💬 Chat',
  description: 'Botão + menu popup para anexar arquivos (imagens) no chat.',
  usedIn: ['ChatHubPage'],
  example: () => <AttachMenuExample />,
};
